import styles from '../../../styles/agents.module.css';

function WizardStep({ stepNumber, totalSteps, title, description, children, onNext, onBack, onSkip, canProceed = true, isOptional = false }) {
    const progress = (stepNumber / totalSteps) * 100;

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {/* Progress bar */}
            <div style={{
                marginBottom: '2em',
                background: '#e1e4e8',
                borderRadius: '4px',
                height: '8px',
                overflow: 'hidden'
            }}>
                <div style={{
                    width: `${progress}%`,
                    height: '100%',
                    background: '#1f6feb',
                    transition: 'width 0.3s'
                }} />
            </div>

            {/* Step header */}
            <div style={{ marginBottom: '2em' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1em',
                    marginBottom: '0.5em'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        background: '#1f6feb',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}>
                        {stepNumber}
                    </div>
                    <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 600, color: '#24292e' }}>
                        {title}
                    </h2>
                    {isOptional && (
                        <span style={{
                            padding: '0.25em 0.75em',
                            borderRadius: '12px',
                            background: '#f6f8fa',
                            color: '#586069',
                            fontSize: '12px',
                            fontWeight: 500
                        }}>
                            Optional
                        </span>
                    )}
                </div>
                {description && (
                    <p style={{ color: '#586069', fontSize: '14px', marginLeft: '56px', marginTop: '0.5em' }}>
                        {description}
                    </p>
                )}
            </div>

            {/* Step content */}
            <div style={{ marginBottom: '2em' }}>
                {children}
            </div>

            {/* Navigation */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '2em',
                borderTop: '1px solid #e1e4e8'
            }}>
                <div>
                    {stepNumber > 1 && (
                        <button
                            type="button"
                            onClick={onBack}
                            className={`${styles.button} ${styles.buttonSecondary}`}
                        >
                            ← Back
                        </button>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '1em' }}>
                    {isOptional && onSkip && (
                        <button
                            type="button"
                            onClick={onSkip}
                            className={`${styles.button} ${styles.buttonSecondary}`}
                        >
                            Skip
                        </button>
                    )}
                    {stepNumber < totalSteps ? (
                        <button
                            type="button"
                            onClick={onNext}
                            disabled={!canProceed}
                            className={`${styles.button} ${styles.buttonPrimary}`}
                        >
                            Next →
                        </button>
                    ) : (
                        <button
                            type="button"
                            onClick={onNext}
                            disabled={!canProceed}
                            className={`${styles.button} ${styles.buttonPrimary}`}
                        >
                            Create Agent
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default WizardStep;
